import React, { useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';

import Header from '../components/Header';
import BlogList from '../components/BlogList';
import Footer from '../components/Footer';

import BlogContent from '../components/BlogContent';

export default function Blogs(props) {
  const [blogPath, setBlogPath] = useState('');

  useEffect(function() {
    let p = props.location.pathname;
    let arr = p.split('/');
    let blogPath = arr[arr.length - 2] + '-' + arr[arr.length - 1];
    setBlogPath(blogPath);
  });

  return (
    <div className='container mt-2'>
      <Header />
      <Switch>
        <Route path='/blogs' component={BlogList} exact />
        <Route path='/blogs/:slug/'>
          <BlogContent blogPath={blogPath} />
        </Route>
      </Switch>
      <hr />
      <Footer />
    </div>
  );
}
